export enum TabsMode {
  classic = 'classic',
  modern = 'modern'
}
